import { verificationsApi } from '../../../data/verificationsApi';

/** Dimension item ({ value, name }) for enum-backed dropdowns — mirrors the backend `EnumView`. */
export interface EnumOption {
  value: string;
  name: string;
}

/**
 * Verification dimension endpoints (spec 008). Enumerate the authorization SmartEnums from the server
 * (`GET /verification/dimensions/*`) so dropdowns never duplicate the backend `StayType` /
 * `AuthorizationStatus` enums. Mirrors the worklist-types dimension already consumed by the worklist
 * feature. The data is global reference data — RTK Query caches it app-wide.
 */
export const verificationDimensionEndpoints = verificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    getStayTypes: builder.query<EnumOption[], void>({
      query: () => ({ url: '/verification/dimensions/stay-types', method: 'GET' }),
    }),
    getAuthorizationStatuses: builder.query<EnumOption[], void>({
      query: () => ({ url: '/verification/dimensions/authorization-statuses', method: 'GET' }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetStayTypesQuery, useGetAuthorizationStatusesQuery } = verificationDimensionEndpoints;
